import { render, staticRenderFns } from "./LevyCollectionNavigator.vue?vue&type=template&id=1a354933&"
import script from "./LevyCollectionNavigator.vue?vue&type=script&lang=js&"
export * from "./LevyCollectionNavigator.vue?vue&type=script&lang=js&"
import style0 from "./LevyCollectionNavigator.vue?vue&type=style&index=0&id=1a354933&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports